<template>
        <v-card class="elevation-10">
            <v-card-title>
                <v-container grid-list-md text-xs-center>
                    <v-layout row wrap>
                        <v-flex xs4>
                            <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Search"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs8></v-flex>
                        <v-flex xs2>
                            <v-btn :href="BASE + 'sample-orders/export?search=' + search + '&sortBy=' + sortBy + '&order=' + order + '&download_token=' + download_token" target="_blank">Export</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="samples.data"
                    :search="search"
                    :pagination.sync="pagination"
                    hide-actions
                    :loading="loading"
                    :total-items="8"
                    v-on:update:pagination="ordenar"
            >
                <template slot="items" slot-scope="props">
                    <tr>
                        <td @click="ver(props.item)">
                            {{ props.item.request_ }}
                        </td>
                        <td @click="ver(props.item)" class="text-xs" v-if="props.item.status_id == 4">Sent</td>
                        <td @click="ver(props.item)" class="text-xs" v-if="props.item.status_id != 4">{{ props.item.status_name }}</td>
                        <td @click="ver(props.item)" class="text-xs">{{ props.item.track_number }}</td>
                        <td @click="ver(props.item)" class="text-xs">{{ props.item.date }}</td>
                        <td class="layout px-0">
                            <v-btn
                                    v-if="props.item.status_id > 3"
                                    fab
                                    dark
                                    small
                                    color="secondary"
                                    :to="{ name: 'agent.sample-orders.detail', params : { id : props.item.id } }"
                            >
                                <v-icon color="primary">remove_red_eye</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
            <div class="text-xs-center pt-4 pb-4" v-if="samples.data">
                <v-pagination
                        v-model="page"
                        :length="last_page"
                        color="secondary"
                        circle
                        :total-visible="7"
                        @input="setPage"
                ></v-pagination>
            </div>
        </v-card>
</template>

<script>
    import { BASE } from '../../../config';

    export default {
        data () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {sortBy: 'date', descending: true},
                loading: false,
                headers: [
                    {
                        text: 'Sample request',
                        align: 'left',
                        sortable: true,
                        value: 'request_'
                    },
                    { text: 'Status', value: 'status_id', sortable: true },
                    { text: 'Tracking number', value: 'track_number', sortable: true },
                    { text: 'Date', value: 'date', sortable: true },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                samples: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                sortBy: 'date',
                order: 'asc',
                BASE: BASE,
                download_token: null,
            }
        },
        created: function() {
            this.checkUser();
            this.getSamples();
            this.debouncedGetSamples = _.debounce(this.getSamples, 500)
        },
        computed : {
            active_client : function(){
                return this.$store.getters.getActiveClient;
            }
        },
        watch: {
            active_client: function() {
                this.getSamples();
            },
            search: function () {
                this.loading = true;
                this.debouncedGetSamples();
            },
            last_page: function () {
                if (this.page > this.samples.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods : {
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.download_token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            ordenar (payload) {
                this.sortBy = payload.sortBy;
                if (payload.descending) {
                    this.order = 'desc';
                } else {
                    this.order = 'asc';
                }
                this.getSamples();
            },
            ver(item) {
                if (item.status_id > 3) {
                    this.$router.push({ name: 'agent.sample-orders.detail', params : { id : item.id } });
                }
            },
            setPage (page) {
                this.page = page;
                this.getOrders();
            },
            getSamples () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        sortBy: this.sortBy,
                        order: this.order
                    }
                };
                this.$store.dispatch('getSamples', params).then((res) => {

                    this.samples = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/agent/samples/ListComponent.vue